export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n6_realisation-de-soi.f5bda276.svg";